import { useNavigate } from 'react-router-dom';
import { useCallback } from 'react';
import { useAppDispatch } from '../../../../../../app/store';
import { writeoffApi } from '../../../../../../services/WriteoffService';
import { WriteoffSearchView } from '../../../../../../services/WriteoffService/types';

/**
 * Hook for handling writeoff navigation from lookup grid.
 */
export function useLookupNavigation(company: string, center: string) {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const navigateToWriteoff = useCallback(
    (writeoffId: string) => {
      dispatch(writeoffApi.util.invalidateTags(['Writeoff']));
      navigate(
        `/writeoffs/edit?company=${encodeURIComponent(company)}&center=${encodeURIComponent(center)}&id=${encodeURIComponent(writeoffId)}`
      );
    },
    [navigate, dispatch, company, center]
  );

  const handleRowSelected = useCallback(
    (args: any) => {
      const selectedItem = args.data as WriteoffSearchView;
      if (selectedItem?.id) {
        navigateToWriteoff(selectedItem.id);
      }
    },
    [navigateToWriteoff]
  );

  return { navigateToWriteoff, handleRowSelected };
}
